/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Button, Checkbox } from 'antd'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import { WithdrawFormPaylaod } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { withdrawalbankSections } from './withdrawal-bank-form.sections'
import { showNotification, extractFormData, getFileFromBlobUrl } from 'src/core/helpers'
import {
  resetWithdrawPayPalState,
  summaryWithdrawSelector,
  userAuthenticatedState,
  createWithdrawPayPal,
  getBalance,
} from 'src/features'

interface WithdrawBankTransferFormProps {
  amount: number
  selectCurrencyId: number
  handleCancel: () => void
}

const WithdrawBankTransferForm: React.FC<WithdrawBankTransferFormProps> = ({
  amount, selectCurrencyId, handleCancel
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [showInvoiceField, setShowInvoiceField] = useState(false)
  const [IBAN, setIBAN] = useState<boolean>(false)
  const [disableAcountNumber, setDisableAccountNumber] = useState(false)
  const [disableIBANNumber, setDisableIBANNumber] = useState(false)
  const { loading, success, error } = useAppSelector(summaryWithdrawSelector)
  const user = useAppSelector(userAuthenticatedState)
  const [form] = Form.useForm()


  const onSubmit = async (values: WithdrawFormPaylaod) => {
    const payload = {
      ...values,
      amount,
      iban: values.iban || '',
      currency_token: selectCurrencyId,
      kind: 'bank',
      cancellation_certificate: values.cancellation_certificate ?  await getFileFromBlobUrl(values.cancellation_certificate) : '',
      partnership_invoice: values.partnership_invoice ? await getFileFromBlobUrl(values.partnership_invoice) : '',
      to_email: null,
    }
    dispatch(createWithdrawPayPal(extractFormData(payload)))
  }

  const resetForm = () => {
    form.resetFields()
    dispatch(resetWithdrawPayPalState())
    handleCancel()
  }


  useEffect(() => {
    if (success) {
      dispatch(getBalance())
      showNotification('success', t('Summary.WithdrawSuccess'))
      resetForm()
    }
    if (error) {
      showNotification('error', error)
      resetForm()
    }
  }, [dispatch, success, error])

  const handleIBANInputValue = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setDisableAccountNumber(false)
    if (target.value.length > 0) {
      setDisableAccountNumber(true)
      form.validateFields()
    }
  }

  const handleAccountNumberInputValue = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setDisableIBANNumber(false)
    if (target.value.length > 0) {
      setDisableIBANNumber(true)
      form.validateFields()
    }
  }

  const isPartnerOrAffiliate = user.is_partner || user.is_affiliate
  const showCheckBox = isPartnerOrAffiliate && user.is_project_developer
  const handleCheck =(e) => { setShowInvoiceField(e.target.checked) }
  const showInvoiceInput = isPartnerOrAffiliate && (!user.is_project_developer || showInvoiceField)

  const sections = withdrawalbankSections(
    t, IBAN, disableIBANNumber, handleIBANInputValue,
    setIBAN, disableAcountNumber, handleAccountNumberInputValue, user,
    showInvoiceInput
  )
  return <Form
    name='basic'
    autoComplete='off'
    form={form}
    onFinish={onSubmit}
  >
    {/* Fields */}
    {sections.map((item, idx) => <div key={idx}>
      {showCheckBox && idx === sections.length-1&&
        <Checkbox className='mb-5' checked={showInvoiceField} onChange={handleCheck}>
          {t('Summary.PartnershipCheckbox')}
        </Checkbox>}
      {item.isVisible && <>
        {item.label ? <>
          <CustomText label={item.label} type={null} />
          <item.formComponent {...item.formProps} />
        </>: <item.formComponent {...item.formProps} />}
      </>}
    </div>)}

    {/* Submit Button */}
    <Button
      block
      size='large'
      type='primary'
      htmlType='submit'
      loading={loading}
      className='radius-100'
    >{t('Summary.Withdraw')}
    </Button>
  </Form>
}

export default WithdrawBankTransferForm
